import React, { useState } from 'react';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import { useSwipeable } from 'react-swipeable';
import { useLanguage } from '@hilma/netina2all';
import clsx from 'clsx';

interface SliderProps {
    items: React.ReactNode[]
    itemsToShow: number,
    width: string,
    itemWidth?: string,
    itemHeight?: string,
    sideBounce?: number,
    speed?: string,
    greyBackground?: boolean
}

const Slider: React.FC<SliderProps> = (props) => {

    const language = useLanguage()
    const [currentIndex, setCurrentIndex] = useState(() => {
        if (language === 'he') return 0
        else return props.items.length - props.itemsToShow
    })
    const [distance, setDistance] = useState(0);

    const handlers = useSwipeable({
        onSwiped: (e) => {
            setDistance(0)
            switch (e.dir) {
                case ('Right'):
                    goLeft();
                    break
                case ('Left'):
                    goRight();
                    break
            }
        },
        onSwiping: (e) => {
            if (e.dir !== 'Left' && e.dir !== 'Right') return
            if ((e.dir === 'Left' && currentIndex <= 0 && (-1 * e.deltaX) > window.innerWidth * (props.sideBounce || 6) / 100)) return
            if ((e.dir === 'Right' && currentIndex >= props.items.length - props.itemsToShow && e.deltaX > window.innerWidth * (props.sideBounce || 6) / 100)) return
            setDistance(-1 * e.deltaX)
        }
    })

    const goLeft = () => {
        if (currentIndex < props.items.length - props.itemsToShow) {
            setCurrentIndex(prevIndex => { return prevIndex + 1 })
        }
    }

    const goRight = () => {
        if (currentIndex > 0) {
            setCurrentIndex(prevIndex => { return prevIndex - 1 })
        }
    }

    return (
        <div className='flex arrows-direction'>
            <div className={`${props.greyBackground == false ? 'white' : ''} ${currentIndex > 0 ? 'slider-arrow' : 'slider-arrow slider-arrow-opacity'}`}>
                <ArrowForwardIosIcon fontSize='inherit' onClick={goRight} />
            </div>
            <div {...handlers} id='slider' className={`${props.greyBackground == false ? 'white' : ''}`} style={{ width: props.width || '100vw' }}>
                <div id='contain-slider-items' className={`${props.greyBackground == false ? 'white' : ''}`} style={{
                    transition: distance ? `margin-right 0.1s linear` : `margin-right ${props.speed || '0.5s'} ease`,
                    marginRight: `calc(-1 * ${currentIndex} * ${parseInt(props.width) / props.itemsToShow + 'vw'} + ${distance}px)`
                }}>
                    {props.items && props.items.map((item, i) => {
                        return (
                            <div
                                style={{
                                    width: parseInt(props.width) / props.itemsToShow + 'vw',
                                }} key={i}>
                                {item}
                            </div>
                        )
                    })}
                </div>
            </div>

            <div className={`${props.greyBackground == false ? 'white' : ''} ${currentIndex < props.items.length - props.itemsToShow ? 'slider-arrow' : 'slider-arrow slider-arrow-opacity'}`} >
                <ArrowBackIosIcon fontSize='inherit' onClick={goLeft} />
            </div>
        </div>
    )
}

export default Slider;